export const SET_USER = 'SET_USER';
export const SET_ALL_USER = 'SET_ALL_USER';
export const SET_USER_ISAUTH = 'SET_USER_ISAUTH';
export const SET_USER_ISLOADING = 'SET_USER_ISLOADING';
